import React, { useState, useEffect, useRef } from 'react';

interface CountdownProps {
  initialSeconds: number;
  onCountdownEnd?: () => void;
  onCountdownTick?: (seconds: number) => void;
}

const Countdown = ({
  initialSeconds,
  onCountdownEnd,
  onCountdownTick,
}: CountdownProps) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const countdownRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    countdownRef.current = setInterval(() => {
      setSeconds(second => {
        const newSeconds = second - 1;

        if (onCountdownTick) {
          onCountdownTick(newSeconds);
        }

        return newSeconds;
      });
    }, 1000);

    return () => countdownRef.current && clearInterval(countdownRef.current);
  }, []);

  useEffect(() => {
    if (seconds <= 0 && onCountdownEnd) {
      onCountdownEnd();

      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    }
  }, [seconds]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(remainingSeconds).padStart(2, '0');

  return <span>{`${paddedMinutes}:${paddedSeconds}`}</span>;
};

export { Countdown };
